export const stringsKey = "CountryDialog";
export const englishStrings = {
	countryName: "Country Name",
	projectName: "Project Name",
	countryCode: "Country Code",
	twilioAccountSid: "Twilio Account Sid",
	twilioAuthToken: "Twilio Auth Token",
	azureResourceGroupName: "Azure Resource Group Name",
	sharepointSiteId: "Sharepoint Site ID",
	sharepointDriveId: "Sharepoint Drive ID",
	exclusionList: "Unsupported Template Types",
	unsupportedTemplateInformation:
		"By default, all template types are enabled. Select any template types that are unsupported for this country. Unsupported template types cannot be used in Reach.",
	connectivity: "Connectivity",
	intergrations: "Integrations",
	dchLabel: "DCH",
	dchCountryLabel: "The Country name for you DCH Instance",
	dchEnvironmentLabel: "The Environment Name for you DCH Instance",
	dchApiKeyLabel: "The API Key uses to connect Reach with DCH's API",
	dchApiURLLabel: "E.G. https://app-productx-<YourENV>.azurewebsites.net",
	dchMessage: "You can find the follow configurations from your DCH instance",
	smsLabel: "SMS",
	voiceLabel: "Voice",
	whatsappLabel: "Whatsapp",
	ussdLabel: "USSD",
	outboundSMSLabel: "Outbound SMS",
	inboundSMSLabel: "Inbound SMS",
	senderIdPreservedLabel: "Sender ID Preserved",
	alphaNumericSupportLabel: "Alphanumeric Support",
	voiceConnectivityMethodLabel: "Voice Connectivity Method",
	closeButton: "Close",
	submitButton: "Submit",
	editCountryLabel: "Edit",
	addCountryLabel: "Add",
	countryDetailMessage: "Country Detail",
	projectNameErrorText: "The Project Name field is required",
	countryCodeErrorText: "The Country Code field is required",
	batchMessaging: "Batch Messaging",
	requestsForHelpText: "Requests for Help",
	surveysText: "Surveys",
	connectivityNoteMessage:
		"Make sure to tick the country in the Twilio account GeoPermissions.",
	whatsappNoteMessage:
		"Link to the documentation for registering the phonenumber:",
	whatsappBlockedCountryMessage:
		"Whatsapp connectivity has been blocked in the selected country.",
	ussdNoteAfricasTalkingLink: "Link to setup a USSD code on Africa's Talking:",
	ussdNoteTelerivetLink:
		"Link to setup a Telerivet account, used for hosting the USSD service:",
	noneText: "None",
	registrationRequiredText: "Registration Required",
	dynamicText: "Dynamic",
	twilioPhoneNumberText: "Twilio Phone number",
	twilioSipTrunkingText: "Twilio SIP Trunking (to on prem PBX)",
	telerivetText: "Telerivet",
	saveCountrySuccessMessage: "Country detail saved successfully!",
	saveCountryErrorMessage: "Error submitting country detail, Please try again.",
	getCountryCodeErrorMessage:
		"Error loading country code list, Please try again.",
	twilioOptionLabel: "Twilio",
	vodafoneOptionLabel: "Vodafone",
	africasTalkingOptionLabel: "Africa's Talking",
	africasTalkingUserName: "Africa's Talking API User Name",
	africasTalkingApiKey: "Africa's Talking API Key",
	whatsappEnabledPhoneNumberLabel: "WhatsApp Enabled Phone Number",
	vodafoneProviderUsername: "Vodafone Provider Username",
	vodafoneProviderPassword: "Vodafone Provider Password",
	vodafoneApiBaseUrl: "Vodafone Api Base Url",
	vodafoneDistributionId: "Vodaphone Distribution ID",
	senderId: "Sender ID",
};
